<template>
  <div id="map-controls-sidebar-search">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeSearchSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">検索</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_SEARCH_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>

        <form-vessel-search :map="map"/>

        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pt-4 pb-6"
          :settings="settings"
        >

        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FormVesselSearch from "./SearchInput";
import {createNamespacedHelpers} from "vuex";

// Mixins
import {ColorMixin} from "@/mixins";

const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin],
  components: {
    VuePerfectScrollbar,
    FormVesselSearch
  },
  data() {
    return {
      vessels: [],
      active: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  props: {
    map: Object
  },
  watch: {
    ...mapStateOfLiveMap({
      activeOwnVesselSidebar: state => state.activeOwnVesselSidebar
    }),
    activeMapControlsSidebar(val) {
      this.setActive(val)
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      ownVessels: state => state.ownVessels,
      activeSearchSidebar: state => state.activeSearchSidebar
    }),
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_SEARCH_SIDEBAR",
    ]),
    updatePrimaryColor(color) {
      this.primaryColor = color;
      this.$vs.theme({primary: color});
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-search {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
  }
  .vs-input--input:focus {
    border: 1px solid $aisea-blue !important;
  }
  .vs-input-primary.isFocus .vs-input--input:focus~.icon-inputx {
    color: $aisea-blue !important;;
  }
}
</style>
